import { ITypedReduxAction } from '../../../common/types/redux';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export enum EIsFirstMapInteractionActionType {
  Toggle = 'IsFirstMapInteraction/Toggle',
}

export type TToggleIsFirstMapInteractionAction = ITypedReduxAction<EIsFirstMapInteractionActionType.Toggle, boolean>;

export type TIsFirstMapInteractionActions = TToggleIsFirstMapInteractionAction;

export const toggleIsFirstMapInteraction = actionGenerator<EIsFirstMapInteractionActionType.Toggle, boolean>(
  EIsFirstMapInteractionActionType.Toggle,
);
